<div class="row">
    <div class="col-12 ">
        <label for="url" class="form-label">Url</label>
        <input type="text" class="form-control" id="url" name="url" ngModel #url="ngModel" [(ngModel)]="authConfig.url"
            required />
    </div>
</div>